module.exports = __webpack_public_path__ + "static/media/REGALITO.f3edc15b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/punch-card/REGALITO.png
// module id = 1342
// module chunks = 0